import React from 'react'
import {
  BundlePlanMobileBilledAnnually,
  BundlePlanMobileCurrency,
  BundlePlanMobilePrice,
  BundlePlanMobilePriceWrapper,
  BundlePlanMobilePeriod,
  BundlePlanMobileName,
  BundlePlanMobileStyled,
  BundlePlanMobileLetsTalk,
} from 'Features/pricing/components/BundlePlanMobile/BundlePlanMobile.styled'
import { RadioButtonGroup, theme } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { PlanTypes } from 'Types/PlansTypes'
import { PlansJson } from 'Types/Plan'
import { Plan } from 'Features/pricing/types/Plan'
import { PRODUCT_TYPES, ProductTypes } from 'Types/ProductTypes'
import { getAmountWithCurrency } from 'Utils/currencyHelper'
import { NUMBER_CONSTS } from './BundlePlanMobile.model'

type BundlePlanMobileProps = {
  key?: string
  planName: PlanTypes
  numOfVisits: number
  onClick?: () => void
  plansJson: PlansJson
  plansDb?: Array<Plan>
  currency: string
  productName: ProductTypes
  selectedPlan?: PlanTypes
  setSelectedPlan: (plan: PlanTypes) => void
}

export const BundlePlanMobile = ({
  planName,
  selectedPlan,
  currency,
  plansDb,
  productName,
  numOfVisits,
  setSelectedPlan,
}: BundlePlanMobileProps) => {
  const { t } = useTranslation('pricing')

  const getPrice = () => {
    const amount = plansDb?.find((plan) => {
      return (
        plan.visitsAllowed === numOfVisits * NUMBER_CONSTS.VISITS_MULTIPLIER &&
        plan.planType === planName &&
        plan.productType.toLowerCase() === productName.toLowerCase() &&
        plan.currency === currency
      )
    })?.amount

    return amount ? Math.ceil(amount / NUMBER_CONSTS.MONTHLY_DIVIDIER) : 0
  }
  const options = [
    {
      value: planName,
      label: '',
    },
  ]
  const letsTalkBz =
    numOfVisits === NUMBER_CONSTS.BZ_MAX_VALUE && productName === PRODUCT_TYPES.BOT_ZAPPING
  const letsTalkPm =
    numOfVisits === NUMBER_CONSTS.PM_MAX_VALUE && productName === PRODUCT_TYPES.PAID_MARKETING
  return (
    <BundlePlanMobileStyled
      onClick={() => setSelectedPlan(planName)}
      css={{
        border: planName === selectedPlan ? `${theme.colors.primaryColor.value} solid 2px` : '',
      }}
    >
      <RadioButtonGroup
        selectedValue={planName === selectedPlan ? planName : ''}
        options={options}
        onChange={() => {}}
      />
      <BundlePlanMobileName>{planName}</BundlePlanMobileName>
      {planName === 'Enterprise' || letsTalkBz || letsTalkPm ? (
        <BundlePlanMobileLetsTalk>{t('lets_talk')}</BundlePlanMobileLetsTalk>
      ) : (
        <>
          <BundlePlanMobilePriceWrapper>
            <BundlePlanMobileCurrency>
              {getAmountWithCurrency(currency, undefined)}
            </BundlePlanMobileCurrency>
            <BundlePlanMobilePrice>{getPrice()}</BundlePlanMobilePrice>
            <BundlePlanMobilePeriod>/m</BundlePlanMobilePeriod>
          </BundlePlanMobilePriceWrapper>
          <BundlePlanMobileBilledAnnually>
            {t('bundles.billed_annually')}
          </BundlePlanMobileBilledAnnually>
        </>
      )}
    </BundlePlanMobileStyled>
  )
}
